import React, { Component } from 'react'
import { CARROT } from '../utils/colors'


class Icon extends Component {

    render() {
        return (
            <div style={{color: CARROT}}>
                <span className='icon is-large'><i className={`fa-3x ${this.props.name}`}></i></span>
            </div>
        )
    }

}


export default Icon



// WEBPACK FOOTER //
// ./src/components/icon.js